module.exports = __webpack_public_path__ + "static/img/__9230.b55c1d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9230.jpg
// module id = kDC8
// module chunks = 0